import styled from "@emotion/styled";
import { FlyerDetailPagePreviewLayoutProps } from "./flyer-detail-page-preview-layout.props";
import { BASE_COLORS } from "../../../../../../../../../../emotion-theme";

const gridView = (props: FlyerDetailPagePreviewLayoutProps) => `
  display: grid;
  grid-template-columns: repeat(${props.columns}, 1fr);
  grid-template-rows: repeat(${props.rows}, 1fr);
  gap: 6px 6px;  
`;

const singleCellView = () => `
  display: block;
`;

const gridOrCellView = (props: FlyerDetailPagePreviewLayoutProps) => {
  if (props.columns === 1 && props.rows === 1) {
    return singleCellView();
  }
  return gridView(props);
};

export const FlyerDetailPageDetailLayoutGrid = styled.div`
  ${gridOrCellView}
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
`;

export const HostContainer = styled.div`
  display: block;
  width: ${(props: FlyerDetailPagePreviewLayoutProps) => props.width}px;
  height: ${(props: FlyerDetailPagePreviewLayoutProps) => props.height}px;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 0 10px 10px ${BASE_COLORS.lightGrey};
  margin: 32px auto;
`;
